import api from './axios';

// 목록 조회 (공개, 로그인 불필요)
// params: { heldStartDate, heldEndDate, regionCd } — 전부 선택값, 생략 시 전체 조회
export async function getExplanationList(params) {
  const { data } = await api.get('/explanations', { params });
  return data;
}


// 사업설명회 신청(캘린더 팝업) 등록
// body: { expIdx, name, phone, startTypeCd, region, startupKindCds, content, privacyAgree }
// body 키 이름은 백엔드 ExplanationApplyRequest 필드명과 동일하게 맞춰야 한다.
// startTypeCd: 'NEW'(신규 창업) / 'CONVERT'(브랜드 전환)
// startupKindCds: 'STUDY'(공부방) / 'CLASS'(교습소) / 'ACADEMY'(학원) 중 복수선택 배열
export async function postExplanationApply(body) {
  const { data } = await api.post('/explanation-applies', body);
  return data;
}
